import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {
  ActualizarGestorDTO, AgregarGestorDTO, DetalleUsuarioDTO,
  EliminarGestorDTO,
  GestorDTO,
  ListaGestorDTO, ModificarGestorDTO, ObtenerEmpresasGestorDTO, RespEliminarGestorDTO,
} from '../../modules/empresas/models/gestorDTO';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsuariosGestoresService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/empresa-persona-rol';
  constructor(private http: HttpClient) { }

  agregarGestor(gestor: GestorDTO){
    return this.http.post<AgregarGestorDTO>(
      `${this.apiUrl}${this.baseUrl}/agregar-gestor`,
      gestor
    );
  }

  // Se maneja con HttpParams, debido a que los filtros se envían en la URL y son opcionales
  listarGestores(
    pagina?: number,
    limite?: number,
    idPersonaJuridica?: number,
    idTipoIdentificacion?: number | null,
    identificacion?: string | null,
    nombre?: string | null,
    ordenarPor?: string | null,
    orden?: string | null
  ) {
    let params = new HttpParams()
    const isValid = (v: any) =>
      v !== undefined && v !== null && v !== '' && v !== 'undefined';
    if (pagina) {
      params = params.set('pagina', pagina);
    }
    if (limite) {
      params = params.set('limite', limite);
    }
    if (idPersonaJuridica !== undefined) {
      params = params.set('idPersonaJuridica', idPersonaJuridica);
    }
    if (isValid(idTipoIdentificacion)) {
      params = params.set('idTipoIdentificacion', String(idTipoIdentificacion));
    }
    if (identificacion) {
      params = params.set('identificacion', identificacion);
    }
    if (nombre) {
      params = params.set('nombre', nombre);
    }
    if (ordenarPor) {
      params = params.set('ordenarPor', ordenarPor);
    }
    if (orden) {
      params = params.set('orden', orden);
    }
    return this.http.get<ListaGestorDTO>(
      `${this.apiUrl}${this.baseUrl}/listar`,
      { params }
    );
  }


  eliminarGestores(gestor: EliminarGestorDTO) {
    return this.http.request<RespEliminarGestorDTO>('DELETE', `${this.apiUrl}${this.baseUrl}/eliminar-gestores`, {
      body: gestor
    });
  }


  verificarUsuario(idTipoIdentificacion: number, identificacion: string) {
    return this.http.get<DetalleUsuarioDTO>(
      `${this.apiUrl}${this.baseUrl}/verificar-usuario?idTipoIdentificacion=${idTipoIdentificacion}&identificacion=${identificacion}`
    );
  }

  actualizarGestor(gestor: ActualizarGestorDTO){
    return this.http.put<ModificarGestorDTO>(
      `${this.apiUrl}${this.baseUrl}/actualizar-gestor`,
      gestor
    );
  }

  obtenerEmpresasPorGestor(idPersona: number): Observable<ObtenerEmpresasGestorDTO> {
    const params = new HttpParams().set('idPersona', idPersona.toString());

    return this.http.get<ObtenerEmpresasGestorDTO>(
      `${this.apiUrl}${this.baseUrl}/obtener-empresas-gestor`,
      { params }
    );
  }
}
